import { env } from "@/env";
import GADConfig from "../google-automated-discount";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const ngSeMerchant = "723951052";

const sweden: MarketConfiguration = {
  code: MarketEnum.se,
  label: "Sweden",
  descriptiveLabel: "Swedish",
  contentfulLocale: ContentfulEnum.se,
  contentfulCountry: "Sweden",
  locale: LocaleEnum.se,
  serviceLocale: ServiceLocaleEnum.se,
  language: {
    code: "sv",
    label: "Swedish",
    flag: "se",
  },
  currency: CurrencyEnum.sek,
  link: "https://www.nordiskagalleriet.se",
  termsSlug: "kopvillkor-e-handel",
  loop54Market: MarketEnum.se,
  adyenMarket: MarketEnum.se,
  elevateMarket: ElevateMarketEnum.se,
  freeShippingEnabled: true,
  freeShippingThreshold: 1000,
  externalStoreId: "ecom-se",
  searchPathName: "sok",
  adyenCheckoutEnabled: false,
  walleyCheckoutEnabled: true,
  walleyB2CStoreId: env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE,
  walleyB2BStoreId: env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE,
  walleyChannelBaseB2B: "ng-se-b2b",
  walleyChannelBaseB2C: "ng-se-b2c",
  walleyWidgetEnabled: true,
  hasTrustPilot: false,
  region: RegionEnum.nordics,
  intraRegionOrder: 0,
  googleAutomatedDiscounts: {
    allowedInTest: {
      allowedMerchants: new Set([ngSeMerchant, GADConfig.testMerchantId]),
      allowedPublicKeys: [
        GADConfig.testPublicKey,
        GADConfig.googleProductionPublicKey,
      ],
    },
    allowedInProd: {
      allowedMerchants: new Set([ngSeMerchant]),
      allowedPublicKeys: [GADConfig.googleProductionPublicKey],
    },
  },
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.nordiskagalleriet.se",
  eurobonus: true,
  eurobonusThreshold: 5000,
};

export default sweden;
